import { Address } from './Address';

export type AddressAndDomain = {
    address: Address;
    domain: string;
};
